import type { Project } from "@storytell/types";

export function orgDefaultProject(projects: ReadonlyArray<Project>, organizationId: string): Project | undefined {
  const candidates = projects.filter((project) => project.organizationId === organizationId);
  return candidates.find((project) => project.default) ?? candidates[0];
}
